export default [
    {
        path: '',
        component: require('./components/AppWrapper.vue').default,
        children: [
            {
                path: 'movies-list',
                component: require('./components/MoviesList.vue').default
            },
            {
                path: 'movie',
                component: require('./components/Movie.vue').default
            },
            {
                path: 'movie/:id',
                component: require('./components/Movie.vue').default
            },
            {
                path: 'contracts-list',
                component: require('./components/ContractsList').default
            },
            {
                path: 'contract/:id',
                component: require('./components/Contract.vue').default
            },
            {
                path: 'profile',
                component: require('./components/Profile.vue').default
            },
            {
                path: 'revenues-monitoring',
                component: require('./components/RevenuesMonitoring').default
            },
            {
                path: 'movies-reports',
                component: require('./components/MoviesReports').default
            },
        ]

    },
    {
        path: '/rights-owners/*',
        component: require('./components/NotFound.vue').default
    }
];
